<div
  fxLayout="column"
  [ngClass]="{
    'sidebar-container': sidebarToggle,
    'sidebar-container-close': !sidebarToggle
  }"
  (mouseenter)="inp = true; toggleSideNav('mouseopen')"
  (mouseleave)="inp = false; toggleSideNav('mouseout')"
>
  <div
    fxLayout="column"
    fxLayoutAlign="start center"
    [@onSideNavChange]="sidebarState"
    [ngClass]="{
      sidebar_menu: sidebarToggle,
      'sidebar_menu-close': !sidebarToggle
    }"
  >
    <mat-nav-list
      [ngClass]="{
        'menu-list': sidebarToggle,
        'menu-list-close': !sidebarToggle
      }"
    >
      <mat-list-item *ngFor="let item of items">
        <a
          fxFlex
          routerLinkActive="active"
          [routerLink]="item.path"
          title="{{ item.label }}"
        >
          <mat-icon
            *ngIf="sidebarToggle"
            class="material-icons-outlined icon icon-flex"
            [@iconAnimation]="sidebarState"
            >{{ item.icon }}</mat-icon
          >
          <mat-icon
            *ngIf="!sidebarToggle"
            matBadge="{{ item.count >= 10 ? '9+' : item.count }}"
            class="material-icons-outlined icon"
            [@iconAnimation]="sidebarState"
            >{{ item.icon }}</mat-icon
          >
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxFlex
            class="menu-item"
            *ngIf="sidebarToggle"
          >
            <span class="label" [@labelAnimation]="sidebarState">{{
              item.label
            }}</span>
            <div class="chip-menu-item" *ngIf="sidebarToggle && item.count">
              {{ item.count >= 10 ? '9+' : item.count }}
            </div>
          </div>
        </a>
      </mat-list-item>
    </mat-nav-list>
  </div>

  <div class="version" fxFlex fxLayout="column" fxLayoutAlign="flex-end center">
    <div
      [ngClass]="{
        support: sidebarToggle,
        'support-close': !sidebarToggle
      }"
    >
      <mat-chip-list *ngIf="zenDeskService.isInitializedAsObsevable() | async">
        <mat-chip (click)="showZenDesk()">
          <mat-icon> help_outline </mat-icon>
          <span *ngIf="sidebarToggle" class="text-chip">SUPPORT</span>
        </mat-chip>
      </mat-chip-list>
    </div>
    <div
      [ngClass]="{
        mt: !sidebarToggle
      }"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <mat-icon>security</mat-icon>
      <span *ngIf="sidebarToggle">Version 1.2.0</span>
    </div>
  </div>
</div>
